
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import CourseList from '../../components/course/course-list.vue'

@Component({
  name: 'package',
  components: { CourseList }
})
export default class extends Vue {
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  list: any = []
  header: any = []
  headerTop: any = []
  page: any = {}
  upId: string = ''
  optionId: string = ''
  pageName: string = ''
  allData: any = {}

  async getList() {
    const res: any = await CourseModule.instrumentPage({ org_id: this.org_id })
    if (res.code === 200) {
      this.list = res.data.page_section[0].entity.entity_data
      this.header = res.data.page_section[0].entity.entity_fields
      this.headerTop = this.header
      this.page = res.data.page_section[0].entity.page
      this.upId = res.data.page_section[0].id
      this.optionId = res.data.page_section[0].entity.id
      this.pageName = res.data.key
      this.allData = res.data
    }
  }
  async upList(val) {
    this.list = val.data
    this.allData = val.allData
  }
  mounted() {
    this.getList()
  }
}
